import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Helper } from '../../../../../utils/helper';
import { CommonModule } from '@angular/common'; // Import CommonModule

import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import {
  DisclaimerInitModel,
  DisclaimerInitVariables,
  DisclaimerModel,
  DisclaimerVariables,
} from '../../../../../models/email-template/disclaimer.interface';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinComponent } from '../../../common/pin/pin.component';
import { BaseComponent } from '../../../common/BaseComponent';
import { VariableMaxLengthService } from '../../../../../services/variable-max-length.service';

@Component({
    selector: 'app-disclaimer',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './disclaimer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './disclaimer.component.scss'
})
export class DisclaimerComponent extends BaseComponent implements OnInit {
  @Input() block: DisclaimerModel = new DisclaimerInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  count: number = 0;

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new DisclaimerInitVariables()
    }
  }

  //placeholders:
  disclaimerPlaceholder: string = 'Enter Disclaimer';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId);
  }

  onChange(value: any, fieldName: keyof DisclaimerVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }
}
